import { CharacterResult } from "common/character/dto/CharacterResult";
import { InputWayTextCharElement } from "common/topic/input_way_text";

export type AddRecognizePosPayload = {
  startPosition: number;
  add: string[];
  deleteCount: number;
};

type AddRecognizePosPayloadRecursive = AddRecognizePosPayload & {
  currentAdd: string;
};

export type AddRecognizePosBorders = {
  i1: number;
  j1: number;
  i2: number;
  j2: number;
};

type AddRecognizePosParams = AddRecognizePosBorders & {
  elN: InputWayTextCharElement[];
};

export function getAddRecognizePosPayload({
  i1,
  j1,
  i2,
  j2,
  elN,
}: AddRecognizePosParams): AddRecognizePosPayload {
  const resRecursive: AddRecognizePosPayloadRecursive = {
    startPosition: -1,
    add: [],
    deleteCount: 0,
    currentAdd: "",
  };
  const borders = normalizeAddRecognizePosPayloadIndexes({ i1, j1, i2, j2 });
  addRecognizePosPayloadInd({ ...borders, elN }, resRecursive);
  let startPosition = resRecursive.startPosition;
  const res: AddRecognizePosPayload = {
    startPosition,
    add: [...resRecursive.add, resRecursive.currentAdd],
    deleteCount: resRecursive.deleteCount,
  };

  return res;
}

function normalizeAddRecognizePosPayloadIndexes(
  borders: AddRecognizePosBorders
): AddRecognizePosBorders {
  const res: AddRecognizePosBorders = {
    ...borders,
  };
  if (borders.i1 > borders.i2) {
    res.i1 = borders.i2;
    res.j1 = borders.j2;
    res.i2 = borders.i1;
    res.j2 = borders.j1;
  } else if (borders.i1 === borders.i2 && borders.j1 > borders.j2) {
    res.j1 = borders.j2;
    res.j2 = borders.j1;
  }

  return res;
}

function addRecognizePositionCheckUpdate(
  i1: number,
  elN: InputWayTextCharElement[],
  addPosPayloadRecursive: AddRecognizePosPayloadRecursive
) {
  if (addPosPayloadRecursive.startPosition === -1) {
    if (elN[i1] && !elN[i1].isCharacter) {
      if (i1 > 0 && elN[i1 - 1].isCharacter) {
        addPosPayloadRecursive.startPosition =
          (elN[i1 - 1].value as CharacterResult).position + 1;
      }
    }
  }
}

function addRecognizePosPayloadInd(
  { i1, j1, i2, j2, elN }: AddRecognizePosParams,
  addPosPayloadRecursive: AddRecognizePosPayloadRecursive
) {
  if (i2 === i1) {
    addPosPayloadElInd({ j1, j2, el: elN[i1] }, addPosPayloadRecursive);
  } else {
    const el1Length = inputWayTextCharElementSValue(elN[i1]).length;
    addPosPayloadElInd(
      { j1, j2: el1Length, el: elN[i1] },
      addPosPayloadRecursive
    );
    addRecognizePosPayloadInd(
      { i1: i1 + 1, j1: 0, i2, j2, elN },
      addPosPayloadRecursive
    );
  }
  addRecognizePositionCheckUpdate(i1, elN, addPosPayloadRecursive);
}

export const inputWayTextCharElementSValue = (el: InputWayTextCharElement) =>
  el.isCharacter ? (el.value as CharacterResult).letter : el.value.toString();

function addPosPayloadElInd(
  { j1, j2, el }: { j1: number; j2: number; el: InputWayTextCharElement },
  addPosPayload: AddRecognizePosPayloadRecursive
) {
  if (j1 < j2) {
    const sValue: string = inputWayTextCharElementSValue(el);
    if (el.isCharacter) {
      addPosPayload.deleteCount++;
      if (addPosPayload.startPosition === -1) {
        addPosPayload.startPosition = (el.value as CharacterResult).position;
        if (j1 > 0) {
          addPosPayload.add.push(sValue.substring(0, j1));
        }
        addPosPayload.currentAdd += sValue.substring(j1, j2);
      } else {
        addPosPayload.currentAdd += (
          el.value as CharacterResult
        ).letter.substring(j1, j2);
      }
      if (j2 < sValue.length) {
        addPosPayload.add.push(sValue.substring(j2));
      }
    } else {
      const sValueAdd = sValue.substring(j1, j2);
      addPosPayload.currentAdd =
        addPosPayload.startPosition === -1
          ? sValueAdd
          : addPosPayload.currentAdd + sValueAdd;
    }
  }
}
